<template>
  <div class="detial" :class="pointCount === '3' && 'detial-reject'">
    <z-steps :active="+curPointCount - 1">
      <z-step
        class="step"
        v-for="(item, index) in horizontal"
        :key="index"
        :title="item.title"
        :image-active="item.imageActive"
        :image-deactive="item.imageDeactive"
      />
    </z-steps>

    <div class="detial-header">
      <div class="detial-header-statusMsg">
        <b>{{ statusMsg }}</b>
      </div>
      <div class="detial-header-content" v-if="!!content">{{ content }}</div>
    </div>

    <section class="detial-content">
      <div class="detial-content-title">赔付申请信息</div>
      <div class="detial-content-title-border" />
      <PayItem title="赔付进程" :value="applyInfo.process" />
      <PayItem title="申请时间" :value="applyInfo.applyTime | formatTime" />
      <PayItem
        title="审核时间"
        :value="applyInfo.auditedTime | formatTime"
        v-if="applyInfo.auditedTime !== '0'"
      />
      <PayItem title="申请金额" :value="applyInfo.applyMoney" />
      <PayItem
        title="赔付时间"
        :value="applyInfo.compensateTime | formatTime"
        v-if="!!applyInfo.compensateTime"
      />
      <PayItem title="拒绝理由" :value="applyInfo.rejectReason" v-if="!!applyInfo.rejectReason" />
      <PayItem
        title="赔付金额"
        :value="applyInfo.compensateMoney"
        v-if="!!applyInfo.compensateMoney && applyInfo.compensateMoney !== '￥0.0'"
      />
    </section>

    <section class="detial-content">
      <div class="detial-content-title">赔付商品信息</div>
      <div class="detial-content-title-border" />
      <div class="product-card">
        <div class="product-card-image">
          <z-image fit="cover" class="cover-image" :src="applyOrderInfo.pic" />
        </div>
        <div class="product-card-info">
          <div class="product-card-info-title">{{ applyOrderInfo.title }}</div>
          <div class="product-card-info-price"><span>售价：</span>{{ applyOrderInfo.price }}</div>
        </div>
      </div>
    </section>

    <section class="detial-content">
      <div class="detial-content-title">赔付订单信息</div>
      <div class="detial-content-title-border" />
      <div class="detial-content-item">
        <div class="detial-content-item-name">订单编号</div>
        <div
          class="detial-content-item-value copy-link"
          :data-clipboard-text="applyOrderInfo.orderId"
        >
          {{ applyOrderInfo.orderId }}
          <z-button size="small" btn-class="copy">复制</z-button>
        </div>
      </div>
      <PayItem title="实付款" :value="applyOrderInfo.payPrice" />
      <PayItem title="下单时间" :value="applyOrderInfo.orderTime | formatTime" />
      <PayItem title="支付时间" :value="applyOrderInfo.payTime | formatTime" />
      <PayItem title="发货时间" :value="applyOrderInfo.shrpTime | formatTime" />
      <PayItem title="成交时间" :value="applyOrderInfo.detailTime | formatTime" />
    </section>

    <z-button-group v-if="pointCount === '3'">
      <z-button btn-class="bottombtn" type="primary" @click="toSelect()">重新申请</z-button>
    </z-button-group>
  </div>
</template>

<script>
import ClipboardJS from 'clipboard'
import native from '@zz-common/native-adapter'
import { Step, Steps, Image, Button, ButtonGroup, Toast } from '@zz-common/zz-ui'
// import { lego } from '@zz-common/lego'
import { queryParams } from '../../../lib/utils'
import { getPayMoneyDetial } from '../../../api/resourceApi'
import PayItem from './PayItem'

const query = queryParams()

export default {
  name: 'DetialComp',
  data() {
    return {
      orderId: query.orderId || this.$route.query.orderId || 0,
      isLoading: false,
      pointCount: '3',
      curPointCount: '0',
      statusMsg: '',
      content: '',
      applyOrderInfo: {},
      applyInfo: {},
      count_three: [
        {
          title: '提交申请',
          imageActive: '08613850-9e87-4ee9-ad70-c12f82628ed0.png',
          imageDeactive: 'fcc807b0-1997-4705-b9f4-377c6e2ee10c.png'
        },
        {
          title: '赔付审核',
          imageActive: '90d60ccf-d525-4479-9e9a-0301c02b40ad.png',
          imageDeactive: 'ffc86878-128f-4788-851f-d9b395567482.png'
        },
        {
          title: '未通过审核',
          imageActive: '2b871739-c034-48fd-9b6f-981af94e4416.png',
          imageDeactive: '9d2727d9-d5cf-4af4-8147-e2150e89d229.png'
        }
      ],
      count_five: [
        {
          title: '提交申请',
          imageActive: '08613850-9e87-4ee9-ad70-c12f82628ed0.png',
          imageDeactive: 'fcc807b0-1997-4705-b9f4-377c6e2ee10c.png'
        },
        {
          title: '赔付审核',
          imageActive: '90d60ccf-d525-4479-9e9a-0301c02b40ad.png',
          imageDeactive: 'ffc86878-128f-4788-851f-d9b395567482.png'
        },
        {
          title: '平台追款',
          imageActive: 'a132c768-bf81-48e4-aa8b-6f72270e042c.png',
          imageDeactive: 'fea0bdf2-74f1-4d88-bb7a-3d387baea380.png'
        },
        {
          title: '操作赔付',
          imageActive: 'e1064210-5575-455d-a5df-a4936a7cca2a.png',
          imageDeactive: 'e6ecda0d-f417-4ffa-aadb-25ad82227e0b.png'
        },
        {
          title: '微信打款',
          imageActive: '8863fa76-c466-48a2-93f3-4f6746671969.png',
          imageDeactive: 'ae599c12-6c93-48d7-bb2c-ffc2eed6ba6c.png'
        }
      ]
    }
  },
  filters: {
    formatTime(timeStamp) {
      return timeStamp ? new Date(Number(timeStamp)).format('YYYY年MM月DD日') : ''
    }
  },
  computed: {
    horizontal() {
      return this.pointCount === '3' ? this.count_three : this.count_five
    }
  },
  components: {
    zImage: Image,
    zStep: Step,
    zSteps: Steps,
    zButtonGroup: ButtonGroup,
    zButton: Button,
    PayItem
  },
  methods: {
    async getDetial() {
      this.loading = true
      const res = await getPayMoneyDetial({ orderId: this.orderId })
      const {
        pointCount = '3',
        curPointCount = '',
        statusMsg,
        content,
        applyOrderInfo = {},
        applyInfo = {}
      } = res || {}
      this.loading = false
      this.pointCount = pointCount
      this.curPointCount = curPointCount
      this.statusMsg = statusMsg
      this.content = content
      this.applyOrderInfo = applyOrderInfo
      this.applyInfo = applyInfo
    },
    toSelect() {
      setTimeout(() => {
        native.skipToUrl({
          targetUrl: `https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneySelect&applySource=reapply&orderId=${this.orderId}`
        })
      }, 300)
    }
  },
  mounted() {
    native.setTitle({
      title: '放心转'
    })
    this.getDetial()
    const clipboard = new ClipboardJS('.copy-link')
    clipboard && clipboard.on('success', function(e) {
      Toast('转转:订单号已复制')
      e && e.clearSelection()
    })

    clipboard && clipboard.on('error', function(_e) {
      Toast('不支持自动复制，请手动复制')
    })
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
